import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import InvestorProfileInvestmentExperienceDummyRepository
  from './infraestructure/repositories/investor-profile-investment-experience-dummy-repository/investor-profile-investment-experience-dummy-repository';
import InvestorProfileInvestmentExperienceHttpRepository
  from './infraestructure/repositories/investor-profile-investment-experience-http-repository';

// Application
import UpdateInvestorProfileInvestmentExperienceCommand
  from './application/commands/update-investor-profile-investment-experience-command';

// Domain
import { InvestorProfileInvestmentExperienceRepository }
  from './domain/repositories/investor-profile-investment-experience-repository';

export default function setupInvestorProfileInvestmentExperience(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';

  container
    .bind<InvestorProfileInvestmentExperienceRepository>(
      TYPES.INVESTOR_PROFILE_INVESTMENT_EXPERIENCE_REPOSITORY,
    ).to(
      withDummies
        ? InvestorProfileInvestmentExperienceDummyRepository
        : InvestorProfileInvestmentExperienceHttpRepository,
    ).inSingletonScope();

  container
    .bind<UpdateInvestorProfileInvestmentExperienceCommand>(
      TYPES.UPDATE_INVESTOR_PROFILE_INVESTMENT_EXPERIENCE_COMMAND,
    ).to(UpdateInvestorProfileInvestmentExperienceCommand)
    .inSingletonScope();
}
